module.exports = __webpack_public_path__ + "img/images.8f20e5c6.png";